import { credentialsTypes } from "../types";

const initState = {
  credentials: [],
  credentialsLoading: false,
  credentialsUpdating: false,
};

export function credentials(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case credentialsTypes.GET_CREDENTIALS_REQUEST: {
      return { ...state, credentialsLoading: true };
    }
    case credentialsTypes.GET_CREDENTIALS_SUCCESS: {
      return { ...state, credentialsLoading: false, credentials: payload };
    }
    case credentialsTypes.GET_CREDENTIALS_FAILURE: {
      return { ...state, credentialsLoading: false, credentials: [] };
    }

    case credentialsTypes.POST_CREDENTIALS_REQUEST: {
      return { ...state, credentialsUpdating: true };
    }
    case credentialsTypes.POST_CREDENTIALS_SUCCESS: {
      return { ...state, credentialsUpdating: false };
    }
    case credentialsTypes.POST_CREDENTIALS_FAILURE: {
      return { ...state, credentialsUpdating: false };
    }

    default:
      return state;
  }
}
